import React, { useState } from 'react';
import {
  useDisclosure,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  useColorModeValue,
  Icon,
  Select,
  useToast
} from '@chakra-ui/react';
import { MdEditDocument } from 'react-icons/md';
import VehicleService from './../../../../../services/VehicleService';
import { ShowToast } from '../../../../../components/toast/AppToast'

export default function AlertDialogExample(props) {

  const toast = useToast()

  const [selectedVehicleCategory, setSelectedVehicleCategory] = useState('')
  const [selectedType, setSelectedType] = useState('')

  const [vehicleCategories, setVehicleCategoryArray] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);

  const [vinNumber,setVinNumber] = useState("")
  const [rego,setRego] = useState("")
  const [make,setMake] = useState("")
  const [model,setModel] = useState("")
  const [year,setYear] = useState("")
  const [status,setStatus] = useState("")

  const token = localStorage.getItem('token');
  const loadVehicleData = async (e) => {
    e.preventDefault();
    onOpen();
    setSelectedVehicleDetails(e.currentTarget.parentElement.id);
    getVehicleCategories();
    
  };

  
  
  const getVehicleCategories = async () => {
    try {
      const response = await VehicleService.getVehicleCategories(
        localStorage.getItem('token'),
      );
      if (response.data && response.status === 201) {
        const methodArray = response.data.object.map((item) => ({
          category: item.category,
        }));
        setVehicleCategoryArray(methodArray);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const getVehicleTypes = async (selectedVehicleCat) => {
    try {
      const response = await VehicleService.getVehicleTypesByCategory(
        token,
        selectedVehicleCat,
      );
      if (response.data && response.status === 201) {
        const returnedData = response.data.object.map((item) => ({
            vehicleT: item.type,
        }));
        setVehicleTypes(returnedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setSelectedVehicleDetails = async (rego) => {
    try {
      const response = await VehicleService.getVehicle(token, rego);
      const vehicle = {
        vinNumber: response.data.object.vinNumber,
        make: response.data.object.make,
        model: response.data.object.model,
        vehicleCategory: response.data.object.vehicleCategory.category,
        vehicleType: response.data.object.vehicleType.type,
      };
      setRego(response.data.object.registration)
      setVinNumber(response.data.object.vinNumber)
      setMake(response.data.object.make)
      setModel(response.data.object.model)
      setYear(response.data.object.year)
      setStatus(response.data.object.vehicleStatus)

      setSelectedVehicleCategory(vehicle.vehicleCategory)
      getVehicleTypes(vehicle.vehicleCategory)
      setSelectedType(vehicle.vehicleType)
    } catch (error) {
      console.log(error);
    }
  };

  const changeCategoryDropDownStates = async (e) => {
    const changedCategory = e.target.value;
    getVehicleTypes(changedCategory)
    setSelectedVehicleCategory(changedCategory)

  }

  const handleVinNumber = ({target:{value}}) => setVinNumber(value)
  const handleMake = ({target:{value}}) => setMake(value)
  const handleModel = ({target:{value}}) => setModel(value)
  const handleYear = ({target:{value}}) => setYear(value)
  const handleType = ({target:{value}}) => setSelectedType(value)
  const handleStatus = ({target:{value}}) => setStatus(value)

  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const iconColor = useColorModeValue('brand.500', 'white');
  

  const updateDetails = async () => {
    try {
      const data = {
        "registration": `${rego}`,
        "make": `${make}`,
        "model": `${model}`,
        "vinNumber": `${vinNumber}`,
        "year": `${year}`,
        vehicleCategory: {
          "category": `${selectedVehicleCategory}`
        },
        vehicleType: {
          "type": `${selectedType}`
        },
        "vehicleStatus": `${status}`
        
      }
      const response = await  ShowToast(toast, VehicleService.updateVehicleDetails(token, data), "Successfully updated vehicle details !", "Oh Sorry. Couldnt update details. Please try again") 
      console.log(response)
      if (response.data && response.status === 201) {

        //adawdwdwdwdwdw
      }
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <>
      <Button onClick={(e) => (loadVehicleData(e))}>
        <Icon
          as={MdEditDocument}
          color={iconColor}
          w="24px"
          h="24px"
        />
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Vehicle Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Rego</FormLabel>
              <Input value={rego} placeholder="Rego Number"/>
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Vin Number</FormLabel>
              <Input
                value={vinNumber}
                placeholder="Vehicle Vin Number"
                onChange={handleVinNumber}
              />
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Make</FormLabel>
              <Input
                value={make}
                placeholder="Vehicle Make"
                onChange={handleMake}
              />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Model</FormLabel>
              <Input
                value={model}
                placeholder="Vehicle Model"
                onChange={handleModel}
              />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Year</FormLabel>
              <Input
                value={year}
                placeholder="Vehicle Year"
                onChange={handleYear}
              />
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Category</FormLabel>
              <Select
                value={selectedVehicleCategory}
                onChange={(e) => changeCategoryDropDownStates(e)}
              >
                {vehicleCategories.map((item) => (
                  <option value={item.category}>{item.category}</option>
                ))}
              </Select>
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Type</FormLabel>
              <Select
                value={selectedType}
                onChange={handleType}
              >
                {vehicleTypes.map((item) => (
                  <option value={item.vehicleT}>{item.vehicleT}</option>
                ))}
              </Select>
            </FormControl>
            
            <FormControl mt={4}>
              <FormLabel>Status</FormLabel>
              <Select onChange={handleStatus} value={status}>
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={updateDetails}>
              Save
            </Button>
            <Button >Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
